import React from 'react'

import { PropsOf } from '../../../system'

type NativeSelectOptionProps = PropsOf<'option'>

export const NativeSelectOption = (props: NativeSelectOptionProps) => (
  <option {...props} />
)
